import { APP_STORE_URL, PLAY_STORE_URL } from "@/data/site";

function AppleIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M16.365 1.43c0 1.14-.467 2.22-1.21 3.02-.78.84-2.07 1.49-3.13 1.4-.13-1.09.42-2.25 1.14-3 .8-.84 2.18-1.46 3.2-1.42zM20.7 17.2c-.55 1.27-.81 1.84-1.52 2.96-.99 1.57-2.39 3.52-4.12 3.53-1.54.01-1.94-1.0-4.03-.99-2.09.01-2.53 1.01-4.07.99-1.73-.02-3.05-1.78-4.04-3.34C-.06 16.0-.4 11.3 1.39 8.79c1.0-1.43 2.58-2.27 4.07-2.27 1.52 0 2.47 1.0 3.73 1.0 1.22 0 1.96-1.0 3.73-1.0 1.33 0 2.74.72 3.75 1.97-3.3 1.8-2.76 6.5.04 7.71z"/>
    </svg>
  );
}

function PlayIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path fill="#00D3FF" d="M3.6 1.8c-.3.3-.5.8-.5 1.4v17.6c0 .6.2 1.1.5 1.4l.1.1L13.5 12 3.7 1.7l-.1.1z"/>
      <path fill="#00F076" d="M17.2 15.7 13.5 12l3.7-3.7 4.4 2.5c1.3.7 1.3 1.9 0 2.6l-4.4 2.3z"/>
      <path fill="#FF3A44" d="M17.2 15.7 13.5 12 3.6 22.2c.4.5 1.2.5 2 .1l11.6-6.6z"/>
      <path fill="#FFC400" d="M17.2 8.3 5.6 1.7c-.8-.4-1.6-.4-2 .1L13.5 12l3.7-3.7z"/>
    </svg>
  );
}

export function StoreBadge({ store, className = "", testId, onDark = false }) {
  const isApple = store === "apple";
  const base = onDark
    ? "bg-sand text-ink hover:bg-sand-dim"
    : "bg-ink text-sand hover:opacity-90 dark:bg-sand dark:text-ink";
  return (
    <a
      href={isApple ? APP_STORE_URL : PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId || (isApple ? "appstore-btn" : "playstore-btn")}
      className={`group inline-flex items-center gap-3 rounded-2xl px-5 py-3 transition-all duration-300 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${base} ${className}`}
    >
      {isApple ? (
        <AppleIcon className="h-7 w-7" />
      ) : (
        <PlayIcon className="h-6 w-6" />
      )}
      <span className="flex flex-col items-start leading-none">
        <span className="text-[10px] font-medium uppercase tracking-wide opacity-80">
          {isApple ? "Download on the" : "Get it on"}
        </span>
        <span className="font-heading text-lg font-semibold">
          {isApple ? "App Store" : "Google Play"}
        </span>
      </span>
    </a>
  );
}

export function AppBadges({ className = "", onDark = false }) {
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <StoreBadge store="apple" onDark={onDark} />
      <StoreBadge store="google" onDark={onDark} />
    </div>
  );
}
